export const SIGN_UP = {
  TITLE: 'Sign Up',
};
